
















































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { VIPIp, db } from "@/loader/public";
import { Route } from "vue-router";

@Component
export default class IpLeaf extends Vue {
	@Prop({ type: VIPIp, required: true })
	public readonly ip!: VIPIp;

	@Prop({ type: Number, default: 0 })
	public readonly level!: number;

	@Prop({ type: Array, default: () => [] })
	public readonly include!: VIPIp[];

	@Prop({ type: [Boolean, Array], default: false })
	public readonly opened!: boolean | VIPIp[];

	public expand: boolean = false;

	public get children(): VIPIp[] {
		let result = db.ips.list.filter(x => x.fk_parent === this.ip.id);
		if (this.include.length) {
			result = result.filter(x => this.include.includes(x));
		}
		return result;
	}

	public select(item: VIPIp | null) {
		this.$emit("select", item);
	}

	public mounted() {
		// if (this.$route.name === "IP") {
		// 	let actualIP = db.ips.list.find(i => i.code === this.$route.params?.code);
		// 	// console.log(actualIP);
		// 	this.expand = actualIP && (actualIP.id === this.ip.id || this.ip.isParentOf(actualIP)) || false;
		// }
		if (Array.isArray(this.opened) && this.opened.find(x => x === this.ip) || this.opened === true) {
			this.expand = true;
		}
	}
}
